import usePosOrderUser from "@/shared/atoms/usePosOrderUser";
import Textfield from "../Input/Textfield";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const Floor = () => {
  const { t } = useTranslation();
  const { register } = useFormContext();
  const [orderUser] = usePosOrderUser();

  return (
    <Textfield
      ref={register({})}
      defaultValue={orderUser?.apartment_number}
      label={t("posOrders.floor")}
      name="order_user.floor"
    />
  );
};

export default Floor;
